import { ChatStoreState } from './chat-store.type';

export const initialState: ChatStoreState = {
  messages: {},
  unReadMessages: {},
};

export const STORE_NAME = 'CHAT';
